export default {
    keysfobs_tab_hex: 'Identificador',
    keysfobs_tab_driver: 'Conductor',
    keysfobs_tab_account: 'Cuenta',
    keysfobs_tab_model: 'Modelo'
};
